import { render } from "./DocumentPdfPreview.vue?vue&type=template&id=4418cc22&scoped=true"
import script from "./DocumentPdfPreview.vue?vue&type=script&lang=js"
export * from "./DocumentPdfPreview.vue?vue&type=script&lang=js"

import "./DocumentPdfPreview.vue?vue&type=style&index=0&id=4418cc22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4418cc22"]])

export default __exports__